interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function LoadingSpinner({ className = '' }: LoadingSpinnerProps) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-[color:var(--brand-500)] border-t-transparent rounded-full animate-spin" />
      </div>
    </div>
  );
}
